import axios from "axios";

export const fetchProductionPlan = async (companyId, startDate, endDate) => {

    //console.log ("fetchProductionPlan:", `api/productionPlan?fromdate=${startDate}&todate=${endDate}&companyKey=${companyId}`);
    const response = await axios.get(`api/productionPlan?fromdate=${startDate}&todate=${endDate}&companyKey=${companyId}`);
    const prodPlan = response.data;
    return prodPlan;
}

export const updateProductionPlans = async (periodId, productionPlans) => {

    const response = await axios.patch(`api/productionPlan?planId=${periodId}`, productionPlans);
    const prodPlan = response.data;
    return prodPlan;
}

export const getOeeDataForPO = async (companyId, productionOrderNo, machineId) => {

    //console.log ("getOeeDataForPO:", `api/OEEData/${companyId}?productionOrderNo=${productionOrderNo}&machineId=${machineId}`);

    const response = await axios.get(`api/OEEData/IntervalMachine/?companyKey=${companyId}&productionOrderNo=${productionOrderNo}&machineId=${machineId}`);
    const prodPlan = response.data;
    return prodPlan;
}

export const getOeeDataCurrentPO = async (companyKey, minDateTime) => {

    //console.log ("getOeeDataCurrentPO:", `api/OEEData/${companyKey}?minDateTime=${minDateTime}`);

    const response = await axios.get(`api/OEEData/CurrentPO/?companyKey=${companyKey}&minDateTime=${minDateTime}`);
    const result = response.data;

    //console.log("response.data", response.data);

    return result;
}

export const postNewPO = async (newPO) => {
    const response = await axios.post(`api/productionPlan`, newPO);
    const result = response.data;
    return result;
}

export const postNewBlock = async (newBlock) => {
    const response = await axios.post(`api/productionPlan/block`, newBlock);
    const result = response.data;
    return result;
}

export const updatePO = async (updatePOData) => {
    const response = await axios.patch(`api/productionPlan`, updatePOData);
    const result = response.data;
    return result;
}

export const saveAllChanges = async (companyKey) => {
    const response = await axios.post(`api/productionPlan/SaveEdit?companyKey=${companyKey}`, {});
    const result = response.data;
    return result;
}

export const saveAllChangesForMachines = async (companyKey, machineIds) => {
    const response = await axios.post(`api/productionPlan/saveeditformachine?machineIds=${machineIds}&companyKey=${companyKey}`, {});
    const result = response.data;
    return result;
}

export const cancelAllChanges = async (companyKey) => {
    const response = await axios.post(`api/productionPlan/CancelEdit?companyKey=${companyKey}`, {});
    const result = response.data;
    return result;
}

export const cancelChangesForMachine = async (companyKey, machineIds) => {
    const response = await axios.post(`api/productionPlan/cancelchangesformachine?machineIds=${machineIds}&companyKey=${companyKey}`, {});
    const result = response.data;
    return result;
}

export const getProductionPlanInfo = async (productionOrderId, companyKey) => {
    const response = await axios.get(`api/productionPlan/getinfo?productionOrderId=${productionOrderId}&companyKey=${companyKey}`, {});
    const result = response.data;
    return result;
}


// Blockers
export const getBlockers = async () => {
    const response = await axios.get(`api/productionPlanBlocker`, {});
    const result = response.data;
    return result;
}
export const postBlocker = async (newBlocker) => {
    const response = await axios.post(`api/productionPlanBlocker`, newBlocker);
    const result = response.data;
    return result;
}
export const updateBlocker = async (updateBlockerData) => {
    const response = await axios.patch(`api/productionPlanBlocker`, updateBlockerData);
    const result = response.data;
    return result;
}
export const deleteBlocker = async (deleteBlockerId) => {
    const response = await axios.delete(`api/productionPlanBlocker/${deleteBlockerId}`);
    const result = response.data;
    return result;
}

export const getItemMachinesForItem = async (itemNo, companyKey) => {
    const response = await axios.get(`api/ItemMachine/byitem/${itemNo}?companyKey=${companyKey}`);
    const result = response.data;
    return result;
}

export const getItemMachinesForMachineName = async (machineName, companyKey) => {
    //If machineName == "" or null then all items will be returned

    if (machineName === undefined || machineName === null || machineName === "") {
        machineName = "null";
    }
    
    const response = await axios.get(`api/ItemMachine/bymachine/${machineName}?companyKey=${companyKey}`);
    const result = response.data;
    return result;
}


